import React from 'react';
import PropTypes from 'prop-types';
import useIterateModifiers from '@/hooks/useIterateModifiers';

const Chips = ({
  modifiers,
  iconModifiers,
  iconInside,
  closeChip,
  customHTMLContent,
}) => {
  const modifiersString = useIterateModifiers('dln-chips--', modifiers);
  const modifiersIconString = useIterateModifiers('dln-icn--', iconModifiers);

  return (
    <div className={`dln-chips ${modifiersString}`}>
      <div className='dln-chips__wrapper'>
        {iconInside && (
          <i className={`dln-icn ${modifiersIconString}`}>{iconInside}</i>
        )}
        {closeChip && (
          <button type='button' className='dln-btnIcon dln-btnIcon--close'>
            <i className='dln-icn'>8</i>
          </button>
        )}
        <div className='dln-chips__content'>
          <span
            dangerouslySetInnerHTML={{
              __html: customHTMLContent,
            }}
          />
        </div>
      </div>
    </div>
  );
};

Chips.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.string),
  iconModifiers: PropTypes.arrayOf(PropTypes.string),
  iconInside: PropTypes.string,
  closeChip: PropTypes.bool,
  customHTMLContent: PropTypes.string.isRequired,
};

Chips.defaultProps = {
  modifiers: [],
  iconModifiers: [],
  iconInside: null,
  closeChip: false,
};

export default Chips;
